<template>
  <aside class="details">
    <transition
      name="fade-up-quick"
      @after-enter="handleTransitionEnd"
      @after-leave="handleTransitionEnd"
    >
      <div v-if="visible" class="details__wrap">
        <div class="details__close"><close-button @click="$emit('close')"/></div>
        <details-gallery :items="gallery"/>
        <div class="details__inner">
          <span class="details__content details__content--name" v-html="name"/>
          <span class="details__content details__content--address" v-html="address"/>
          <p class="details__paragraph" v-html="description"/>
          <!-- <details-audio/> -->
          <ul class="details__tags">
            <li
              v-for="(tag, i) in tags"
              :key="i"
              class="details__tag"
              v-html="tag"
            />
          </ul>
        </div>
      </div>
    </transition>
  </aside>
</template>

<script>
import ButtonComponent from '@/components/Button'
import CloseButton from '@/components/CloseButton'
import DetailsGallery from '@/containers/Details/DetailsGallery'
import DetailsAudio from '@/containers/Details/DetailsAudio'

export default {
  components: {
    ButtonComponent,
    CloseButton,
    DetailsGallery,
    DetailsAudio
  },
  props: {
    gallery: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleTransitionEnd () {
      this.$emit('transitionEnd')
    }
  }
}
</script>

<style lang="scss" scoped>
  .details {
    width: 100%;
    background: {
      color: $accent-color;
      size: cover;
      image: url('/img/sidebar-bg.png');
    }
    overflow: auto;

    padding: 50px 20px 0;

    position: relative;
    height: calc(100vh - 150px);
    top: 150px;

    @include media-up(md) {
      height: 100vh;
      top: 0;
      padding: 100px 0 0;

      overflow: hidden;

      &__wrap {
        position: relative;
        max-height: 100%;
        overflow: auto;
        padding: 0 20px;

        &::-webkit-scrollbar-thumb {
          background-color: #6b0d0d;
        }

        &::-webkit-scrollbar {
          width: 13px;
        }
      }
    }

    @include media-up(lg) {
      padding: 150px 0 0;

      &__wrap {
        padding: 0 32px;
      }
    }

    &__close {
      position: absolute;
      top: 10px;
      right: 20px;

      @include hide-up(md);
    }

    &__inner {
      @include media-up(md) {
        padding-left: 20px;
      }
    }

    &__content {
      @include font($akrobat-font, 900);

      max-width: 80%;

      font-size: 15px;
      line-height: 1.25;
      letter-spacing: .4em;

      display: block;

      @include media-up(xl) {
        font-size: 18px;
      }

      &--name {
        text-transform: uppercase;
      }

      &--address {
        font-weight: 300;
        margin-top: 0.625em;
        margin-bottom: 1.5em;
        letter-spacing: .3em;

        @include media-up(xl) {
          font-size: 16px;
        }
      }
    }

    &__paragraph {
      @include font($akrobat-font, 300);
      font-size: 14px;
      line-height: 1.33;
      letter-spacing: .08em;
    }

    &__tags {
      @include font($akrobat-font, 900);
      @include reset-list;

      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: .07em;

      padding-top: 20px;
      padding-bottom: 32px;

      @include media-up(lg) {
        padding-bottom: 40px;
      }
    }

    &__tag::before {
      content: '#';
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Details/Details.vue